/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../devices/external/device';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "InventoryUnit": {
                    "fields": {
                      "serialNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "deviceType": {
                        "type": "squareup.connect.v2.DeviceAttributes.DeviceType",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.solidshop?.nested?.v2?.nested?.resources?.nested?.InventoryUnit) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE InventoryUnit @ squareup/solidshop/v2/resources/inventory_unit.proto at 10:1
 */
export const InventoryUnit = $root.lookupType('squareup.solidshop.v2.resources.InventoryUnit');
fixType(InventoryUnit);
Builder.createAndAttachToType(InventoryUnit);
